module.exports = __webpack_public_path__ + "static/media/TnTMobileDeliveryfinal.87e0428b.png";